export default {"src":"/_next/static/media/info-icon-red.8fedb8d1.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};